import React from 'react';
import { Link } from 'react-router'
import UserIcon from './images/UserIcon'
import PatientIcon from './images/PatientIcon'
import HomeIcon from '../ui/images/HomeIcon'
import HelpIcon from '../ui/images/HelpIcon'
import ownersIcon from "../sidenav/images/settings_white.svg";

import '../home/styles/Resources.scss'
import { Tooltip } from 'react-tippy';

const rowStyle = {
	'justifyContent': 'center'
}

const therapistStyle = {
  padding: "10px"
};



const PracticeAdminMenu = (props) => {
	const { active, params, tooltipOpen, closeTooltip } = props;
 	return (
    <div className="row resources-menu" style={rowStyle}>
      <Link
        to={`/practice_admin/${params.name}`}
        className={active === "home" && "active"}
      >
        <HomeIcon active={active === 'home'} />
        <caption>
          <nobr>Settings</nobr>
        </caption>
      </Link>

      <Tooltip
        title="Manage users here"
        open={tooltipOpen === "users"}
        trigger="manual"
        position="bottom"
        arrow={true}
        size="big"
        hideDelay={4}
        duration={1000}
        unmountHTMLWhenHide={true}
        onRequestClose={() => {
          console.log("call");
          closeTooltip("users");
        }}
      >
        <Link to={`/practice_admin/${params.name}/users`}>
          <UserIcon active={active === "users"} />
          <caption>
            <nobr>Users</nobr>
          </caption>
        </Link>
      </Tooltip>
      <Tooltip
        title="Add patients here"
        open={tooltipOpen === "patients"}
        trigger="manual"
        position="bottom"
        arrow={true}
        size="big"
        hideDelay={4}
        duration={1000}
        unmountHTMLWhenHide={true}
        onRequestClose={() => {
          console.log("call");
          closeTooltip("patients");
        }}
      >
        <Link
          to={`/practice_admin/${params.name}/patients`}
          className={active === "patients" && "active"}
        >
          <PatientIcon active={active === "patients"} />
          <caption>
            <nobr>Patients</nobr>
          </caption>
        </Link>
      </Tooltip>

      <Link
        to={`/practice_admin/${params.name}/getting_started`}
        className={active === "help" && "active"}
      >
        <HelpIcon active={active === "help"} />
        <caption>
          <nobr>Help</nobr>
        </caption>
      </Link>
    </div>
  );
}

PracticeAdminMenu.defaultProps = {
	active: 'areas'
}

export default PracticeAdminMenu;



// WEBPACK FOOTER //
// ./src/components/practice_admin/PracticeAdminMenu.jsx